<template>
  <div class="w3-left-align">
    <i class="fa fa-clock flow-main-color w3-xlarge w3-margin-right"></i>
    <content-header v-bind:title="$t('modifyOpeningHour')"></content-header>

    <div class="w3-margin-top w3-margin-bottom w3-left-align">
      <Column>
        <Row>
          <div class="grid-component">
            <StandardTextBox
              :np-name-error="npNameError"
              v-model:modelText="safeSelectedOpeningHour.day.value"
              :label-name="$t('day')"
              is-disabled="is-disabled"
            />
          </div>
          <div class="grid-component">
            <StandardTextBox
              is-disabled="is-disabled"
              :np-name-error="npNameError"
              v-model:modelText="onSelectedOpeningHour.regimeName"
              :label-name="$t('regime')"
            />
          </div>
        </Row>

        <Row>
          <div class="grid-component">
            <StandardTextBox
              v-model:modelText="safeSelectedOpeningHour.newStartTime"
              :np-name-error="startTimeError"
              :label-name="$t('start-time')"
              :placeholder="'08:00'"
            />
          </div>
          <div class="grid-component">
            <StandardTextBox
              v-model:modelText="safeSelectedOpeningHour.newEndTime"
              :np-name-error="endTimeError"
              :label-name="$t('end-time')"
              :placeholder="'20:00'"
            />
          </div>
        </Row>
      </Column>
      <Column>
        <Row>
          <div class="form-button">
            <SaveButton
              :function-executed="updateExecuted"
              :on-add="updateOpeningHour"
            />
          </div>

          <div class="form-button">
            <DeleteButton :on-delete="deleteOpeningHour" />
          </div>
        </Row>
      </Column>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import StandardTextBox from "@/components/common/StandardTextBox.vue";
import Column from "@/components/common/grid/Column.vue";
import Row from "@/components/common/grid/Row.vue";
import ContentHeader from "@/components/common/ContentHeader.vue";
import SaveButton from "@/components/common/buttons/SaveButton.vue";
import DeleteButton from "@/components/common/buttons/DeleteButton.vue";

export default {
  name: "UpdateOpeningHourSideBar",
  components: {
    DeleteButton,
    SaveButton,
    ContentHeader,
    Row,
    Column,
    StandardTextBox
  },
  emits: ["success", "failure"],
  props: [],
  data() {
    return {
      updateExecuted: false,
      npNameError: "",
      startTimeError: "",
      endTimeError: "",
      /**
       * Need to keep track of the original startTime, because this needs to be passed as a query in the api to determine
       * what domainTimings need to get updated or deleted
       */
      /**
       * Need to keep track of the original startTime, because this needs to be passed as a query in the api to determine
       * what domainTimings need to get updated or deleted
       */
      /**
       * @example {key: "MONDAY", value: "Maandag"}
       */
    };
  },
  computed: {
    ...mapGetters({
      onSelectedOpeningHour: "eventHandlers/onSelectedOpeningHour"
    }),
    safeSelectedOpeningHour: {
      get() {
        return {
          day: this.onSelectedOpeningHour.day ?? '',
          oldStartTime: this.onSelectedOpeningHour.startTime ?? '', 
          newStartTime: this.onSelectedOpeningHour.startTime ?? '', 
          oldEndTime: this.onSelectedOpeningHour.endTime ?? '', 
          newEndTime: this.onSelectedOpeningHour.endTime ?? '', 
          regimeId: this.onSelectedOpeningHour.regimeId ?? ''
        }
      }
    }
  },
  methods: {
    updateOpeningHour() {
      if (!this.isInputValid()) return;
      this.updateExecuted = true;

      const createOpeningHourRequest = {
        id: null,
        day: this.safeSelectedOpeningHour.day.key,
        startTime: this.safeSelectedOpeningHour.newStartTime,
        endTime: this.safeSelectedOpeningHour.newEndTime,
        regimeId: this.safeSelectedOpeningHour.regimeId
      };

      this.$restClient.domainTimings
        .updateDomainTimingsByRegime(
          createOpeningHourRequest,
          this.safeSelectedOpeningHour.regimeId,
          this.createQueryStringForUpdate()
        )
        .then(response => {
          console.log(response);
          this.$emit("success");
        })
        .catch(err => {
          this.updateExecuted = false;
          console.log(err);
          this.$emit("failure", err);
        });
    },
    /**
     * @return Boolean
     */
    isInputValid() {
      let startTimeError = "";
      let endTimeError = "";

      if (this.safeSelectedOpeningHour.newStartTime === "")
        startTimeError = this.$t("INVALID_TEXTFIELD");

      if (this.safeSelectedOpeningHour.newEndTime === "") endTimeError = this.$t("INVALID_TEXTFIELD");

      if (!this.$helper.isTimeValid(this.safeSelectedOpeningHour.newStartTime))
        startTimeError = this.$t("INVALID TIME");
      if (!this.$helper.isTimeValid(this.safeSelectedOpeningHour.newEndTime))
        endTimeError = this.$t("INVALID TIME");

      if (this.safeSelectedOpeningHour.newStartTime >= this.safeSelectedOpeningHour.newEndTime) {
        startTimeError = this.$t("INVALID TIME PERIOD");
        endTimeError = this.$t("INVALID TIME PERIOD");
      }

      this.startTimeError = startTimeError;
      this.endTimeError = endTimeError;

      return this.startTimeError === "" && this.endTimeError === "";
    },
    deleteOpeningHour() {
      this.$restClient.domainTimings
        .deleteDomainTimingsByRegime(
          this.safeSelectedOpeningHour.regimeId,
          this.createQueryStringForDelete()
        )
        .then(response => {
          console.log(response);
          this.$emit("success");
        })
        .catch(err => {
          console.log(err);
          this.$emit("failure", err);
        });
    },
    createQueryStringForDelete() {
      const query =
        "day=" +
        this.safeSelectedOpeningHour.day.key +
        "&startTime=" +
        this.safeSelectedOpeningHour.oldStartTime +
        "&endTime=" +
        this.safeSelectedOpeningHour.oldEndTime;
      return query;
    },
    createQueryStringForUpdate() {
      return "oldSt=" + this.safeSelectedOpeningHour.oldStartTime + "&oldEt=" + this.safeSelectedOpeningHour.oldEndTime;
    }
  }
};
</script>
